import { IReferenceData } from '../interfaces/form/reference-data.model';

export class Location implements IReferenceData {
    id: any;
    description: string;
    sortOrder?: number;
    value?: string;
    locationCode: string;
    locationKey: string;
    dbn: string;
    locationName: string;

    constructor(data: any) {
        this.locationCode = data?.locationCode;
        this.id = data?.locationCode;
        this.dbn = data?.locationCode;
        this.value = data?.locationCode;
        this.description = data?.locationName;
        this.locationName = data?.locationName;
        this.locationKey = data?.locationKey;
    }
}